import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedMutation from './AuthorizedMutation';

const GQL = gql`
  mutation SaveScenes($farmId: String!, $sceneIds: [String!]!) {
    saveScenes(farmId: $farmId, sceneIds: $sceneIds) {
      id
      scenes {
        id
      }
    }
  }
`;

export interface SaveScenesParams {
  farmId: string;
  sceneIds: string[];
}

interface Result {
  saveScenes: SceneDocument[];
}

interface Props {
  onCompleted: (data: SceneDocument[]) => void;
  children: (
    execute: (variables: SaveScenesParams) => void,
    loading: boolean
  ) => React.ReactNode;
}

const SaveScenesProvider: React.StatelessComponent<Props> = (props: Props) => {
  return (
    <AuthorizedMutation mutation={GQL} onCompleted={(data: Result) => props.onCompleted(data.saveScenes)}>
      {(mutateFn, result) =>
        props.children(
          (variables: SaveScenesParams) => mutateFn({ variables }),
          result.loading
        )
      }
    </AuthorizedMutation>
  );
};

export default SaveScenesProvider;



// WEBPACK FOOTER //
// ./src/providers/SaveScenesProvider.tsx